import React from "react";
import "./EstoreWhy.css";
import e1 from "../assets/e1.png";
import e2 from "../assets/e2.png";
import e3 from "../assets/e3.png";
import e4 from "../assets/e4.png";

import circleBg1 from "../assets/circle-bg1.png";


const features = [
  {
    icon: e1,
    title: "Authentic Products Guaranteed",
    description:
      "Every paint product in our online store is manufactured in our quality-controlled facilities, ensuring you receive genuine Glamur Paints products with full warranty coverage.",
    bg: circleBg1,
  },
  {
    icon: e2,
    title: "Competitive Online Pricing",
    description:
      "Enjoy the same honest pricing that has made us famous, with exclusive online offers and bulk purchase discounts available for larger projects.",
    bg: circleBg1,
  },
  {
    icon: e3,
    title: "Fast Delivery Across Pakistan",
    description:
      "With our strong distribution network, especially in Sindh Province, we ensure quick delivery of your paint orders to major cities across Pakistan.",
    bg: circleBg1,
  },
  {
    icon: e4,
    title: "Expert Online Support",
    description:
      "Our online customer support team provides professional guidance on paint selection, quantity calculation, and application techniques via chat, phone, or email.",
    bg: circleBg1,
  },
];

function EstoreWhy() {
  return (
    <section className="estore-why">
      <h2 className="estore-why-title">Why Glamur Paint Products Excel</h2>
      <div className="estore-why-grid">
        {features.map((feature, index) => (
          <div className="estore-why-card" key={index}>
            <h3 className="estore-why-card-title">{feature.title}</h3>
            <div
              className="estore-why-icon-wrapper"
              style={{ backgroundImage: `url(${feature.bg})` }}
            >
                 
              <img
                src={feature.icon}
                alt={feature.title}
                className="estore-why-icon-img"
              />
            </div>
           
            <p className="estore-why-card-text">{feature.description}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default EstoreWhy;
